import Button from '@components/v2/ui/Button/Button';
import { Box } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import { FilterTestIds } from '../../../../utils/testIds/Filter.testIds';
import useWidth from '../../../Hooks/useWidth';

interface FilterApplyFooterProps {
  disabled: boolean;
  onClickApply: () => void;
}

const FilterApplyFooter = ({ disabled, onClickApply }: FilterApplyFooterProps) => {
  const { mobileWidth } = useWidth();
  const { translate } = useTranslation();

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        justifyContent: 'flex-end',
        flexShrink: 0,
        paddingTop: 1,
        backgroundColor: 'background.paper',
        borderTop: `1px solid ${theme.palette.divider}`,
        padding: 1,
      })}
    >
      <Button
        onClick={onClickApply}
        fullWidth={mobileWidth}
        testId={FilterTestIds.APPLY_FILTER_BUTTON}
        variant="contained"
        color="primary"
        disabled={disabled}
        size={mobileWidth ? 'large' : 'medium'}
      >
        {translate(LangEnum.GLOBAL_APPLY)}
      </Button>
    </Box>
  );
};

export default FilterApplyFooter;
